import React, { useEffect } from 'react'

import { Toast } from 'antd-mobile'

import modStyl from './index.module.scss'

import GridLayout, { GridItem } from '../components/grid-layout'
import PanelLayout from '../components/panel-layout'
import UserInfo from '../components/user-info'
import FilterLiner from '../components/icons/filter-liner'
import ChatLiner from '../components/icons/chat-liner'
import TaskLiner from '../components/icons/task-liner'
import Banner from '../components/banner'
import Posts from '../components/posts'
import Dock from '../components/dock'
import WithDockLayout from '../components/with-dock-layout'
import Task from '../components/task'
import Projects from '../components/projects'

const JunHome = ()=> {

  useEffect(()=> {
    window.document.title = "首页"
  }, [])

  return (
    <WithDockLayout>
      <div className={modStyl.container}>
        <Banner/>
        <div className={modStyl.body}>
          <PanelLayout moreText='全部' onMore={()=> Toast.show("敬请期待")} title="待办任务">
            <Task/>
          </PanelLayout>
          <PanelLayout onMore={()=> Toast.show("敬请期待")} title="项目广场" padding="0 12px 16px">
            <Projects/>
          </PanelLayout>
          <PanelLayout onMore={()=> Toast.show("敬请期待")} title="前沿资讯" padding="0 12px 16px">
            <Posts/>
          </PanelLayout>
        </div>
      </div>
    </WithDockLayout>
  )
}

export default JunHome